import { type ReactNode } from 'react'
import { messageFromError } from '@terros/common'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { ErrorScreen, Page, WebGlGuard } from '@components'
import { ManageAccountsPage } from './ManageAccountsPage'

function AreaManagementRoute(): ReactNode {
  return (
    <WebGlGuard>
      <ManageAccountsPage />
    </WebGlGuard>
  )
}

// The WebGL guard covers the known deck.gl/luma failure. This catches any other map
// error and shows its message instead of the root boundary's generic error.
function AreaManagementError({ error }: ErrorComponentProps): ReactNode {
  return (
    <Page>
      <ErrorScreen message={messageFromError(error) ?? 'Something went wrong'} back />
    </Page>
  )
}

export const Route = createFileRoute('/areaManagement/')({
  component: AreaManagementRoute,
  errorComponent: AreaManagementError,
})
